import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M3.360 8.741 C 3.360 8.841,4.317 10.869,6.561 15.520 C 9.075 20.734,10.059 22.706,10.221 22.858 C 10.305 22.937,10.517 23.070,10.693 23.154 C 11.307 23.447,12.037 23.318,12.524 22.831 C 12.811 22.544,13.329 21.560,14.615 18.853 C 16.506 14.877,17.714 12.396,17.800 12.311 C 17.887 12.225,18.101 12.221,21.104 12.256 C 23.118 12.280,24.334 12.313,24.367 12.347 C 24.425 12.406,24.106 13.101,21.708 18.133 C 19.802 22.134,19.307 23.190,19.307 23.256 C 19.307 23.287,20.047 23.306,21.213 23.306 L 23.120 23.305 26.074 17.136 L 29.027 10.966 29.001 10.375 C 28.983 9.966,28.947 9.730,28.885 9.609 C 28.753 9.355,28.440 9.061,28.089 8.863 L 27.782 8.690 21.958 8.705 C 15.416 8.722,15.935 8.687,15.544 9.133 C 15.261 9.456,14.745 10.433,13.685 12.652 C 11.795 16.609,11.477 17.237,11.375 17.218 C 11.259 17.196,11.066 16.811,8.871 12.213 L 7.203 8.720 5.282 8.706 C 4.139 8.698,3.360 8.712,3.360 8.741 ",
      stroke: "none",
      "fill-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }